import React from "react";
import { Field } from "react-final-form";
import { parseIdentity } from "../../../util/forms";

export const BlankableField = (props) => <Field parse={parseIdentity} {...props} />;
